import { Link } from 'react-router-dom'
import { LEGAL_VERSIONS } from '@lib/constants/legal'
import type { LegalDocument } from '@lib/enums/legal-document.enum'

const TITLES: Record<LegalDocument, string> = {
  terms: 'Terms of service',
  privacy: 'Privacy policy',
}

/**
 * The terms of service or the privacy policy, public so anyone can read them
 * before signing up.
 *
 * **The wording is still to be written.** Until it is, this page says so plainly
 * rather than showing placeholder legal text that could be mistaken for the real
 * thing — and signup must not be opened to the public until it is replaced (see
 * DEPLOY_NOTES.md).
 */
export function LegalDocumentPage({ document }: { document: LegalDocument }) {
  return (
    <div className="flex min-h-svh justify-center bg-surface p-6">
      <article className="w-full max-w-2xl space-y-4">
        <Link to="/signup" className="text-sm text-ink-muted underline underline-offset-2">
          Back
        </Link>
        <h1 className="text-2xl font-semibold tracking-tight">{TITLES[document]}</h1>
        <p className="text-sm text-ink-muted">Version {LEGAL_VERSIONS[document]}</p>
        <p className="text-sm text-ink">
          This document is being finalized and will be published here before FLOH Venues opens to new customers.
        </p>
        <p className="text-sm text-ink">
          A note a couple sends the venue about their experience is private to the venue. It isn’t published. The buttons to review the venue on other sites leave the app.
        </p>
      </article>
    </div>
  )
}
